import { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppApc } from '../../api/appApc';
import Logo from '../Logo/Logo';
import { getMenuItems, getUtilityMenuItems } from '../../constants/menu';
import './Sidebar.css';

type SidebarProps = {
    onNavigate?: () => void;
};

function Sidebar({ onNavigate }: SidebarProps) {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [voucherCount, setVoucherCount] = useState<number | null>(null);

    useEffect(() => {
        let cancelled = false;

        const loadVoucherCount = async () => {
            try {
                const response = await AppApc.GetListMyVoucher();
                const list = Array.isArray(response?.data?.data) ? response.data.data : [];
                if (!cancelled) setVoucherCount(list.length);
            } catch (error) {
                console.error('Error fetching voucher count', error);
                if (!cancelled) setVoucherCount((current) => current ?? 0);
            }
        };

        loadVoucherCount();
        return () => {
            cancelled = true;
        };
    }, [pathname]);

    return (
        <aside className="sidebar">
            <div className="sidebar__brand">
                <Logo />
            </div>

            <div className="sidebar__menu">
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[pathname]}
                    items={getMenuItems(voucherCount ?? 0, voucherCount === null, t)}
                    onClick={({ key }) => {
                        navigate(key);
                        onNavigate?.();
                    }}
                />
            </div>

            <div className="sidebar__utility">
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[pathname]}
                    items={getUtilityMenuItems(t)}
                    onClick={({ key }) => {
                        navigate(key);
                        onNavigate?.();
                    }}
                />
            </div>

        </aside>
    );
}

export default Sidebar;
